module.exports = __webpack_public_path__ + "img/quarterstaff_2.3945bab2.png";